import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchGames(ctx, params) {
      return axios.get('/fnf-league/games', { params })
    },
    fetchGame(ctx, gameId) {
      return axios.get(`/fnf-league/games/${gameId}`)
    },
    syncGames(ctx, { season }) {
      return axios.post('/fnf-league/sync', { season })
    },
    createChat(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/chat`)
    },
    // Отправляет в ТГ-чат игры ссылку страницы записи (выбор слотов игроками)
    sendSignupLink(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/send-signup-link`)
    },
    // Оповещает ТГ-чат игры, что добавились новые слоты (ссылка записи та же)
    sendSlotsAdded(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/send-slots-added`)
    },
    // Рассылает игрокам персональные ссылки записи (с шифрованным contact id) в ЛС
    sendSignupLinksDm(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/send-signup-links-dm`)
    },
    // Персональная ссылка записи в ЛС одному игроку
    sendSignupLinkDmToPlayer(ctx, { gameId, planfixContactId }) {
      return axios.post(`/fnf-league/games/${gameId}/send-signup-links-dm`, { planfix_contact_id: planfixContactId })
    },
    // Точечный синк одной игры (результаты тянутся принудительно) — не гоняет весь сезон
    syncGame(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/sync`)
    },
    fetchStandings(ctx, params) {
      return axios.get('/fnf-league/standings', { params })
    },
    fetchHostSlots() {
      return axios.get('/fnf-league/host-slots')
    },
    importHostSlots(ctx, text) {
      return axios.post('/fnf-league/host-slots/import', { text })
    },
    deleteHostSlot(ctx, slotId) {
      return axios.delete(`/fnf-league/host-slots/${slotId}`)
    },
    assignHostSlot(ctx, { gameId, slotId }) {
      return axios.post(`/fnf-league/games/${gameId}/assign-slot`, { slot_id: slotId })
    },
    unassignHostSlot(ctx, gameId) {
      return axios.post(`/fnf-league/games/${gameId}/unassign-slot`)
    },
  },
}
